import { usePageProperties } from 'hooks/usePageProperies'

export const useSiteAddress = () => {
  const { siteAddress } = usePageProperties()
  return siteAddress
}
